import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getNoScanReasons: [],
  getNoScanReasonsSuccess: ['noScanReasons'],
});

export const pclTypes = Types;
export default Creators;
